// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__ZfAzA","expandIcon":"AccordionButton_expandIcon__3krgZ","expanded":"AccordionButton_expanded__CCjHV"};